import React, { useEffect, useState } from 'react';
import Timer from '@material-ui/icons/Timer'; 
import useCountDownTimerStyles from './count-down-timer.styles';
import CONSTANTS from '../constants';

/**
 * Props for the CountDownTimer component
 */
interface CountDownTimerProps {
    // Start time in seconds, count down starts from this number
    // If value not provided, the count down starts from 
    // value CONSTANTS.COUNT_DOWN_TIMER.DEFAULT_START_TIME_SECONDS
    startSeconds?: number; 

    // Interval that indicates how often the timer will update
    // If value not provided, the timer will update for every
    // CONSTANTS.COUNT_DOWN_TIMER.DEFAULT_INTERVAL_SECONDS
    countDownIntervalInSeconds?: number;   

    // Callback function that will be called
    // when the timer reaches 0
    timeExpired: any;

    // Message that will be displayed along with count down
    countDownMessage: string; 
}

/**
 * Count down timer component
 * This component currently only supports count down for seconds
 */
const CountDownTimer: React.FC<CountDownTimerProps> = ({ 
    startSeconds = CONSTANTS.COUNT_DOWN_TIMER.DEFAULT_START_TIME_SECONDS,  
    countDownIntervalInSeconds = CONSTANTS.COUNT_DOWN_TIMER.DEFAULT_INTERVAL_SECONDS,
    timeExpired, 
    countDownMessage}) => {

    const [seconds, setSeconds] = useState(startSeconds);
    const countDownTimerStyles = useCountDownTimerStyles(); 

    useEffect(() => { 
        // countDownOrReset that executes for every countDownIntervalInSeconds
        const timerId = setInterval(() => countDownOrReset(), countDownIntervalInSeconds * 1000)

        // Clean up the interval when the component unmounts
        return () => clearInterval(timerId);
    });

    /**
     * Function that counts down the seconds
     * if the seconds reaches 0, 
     * timeExpired function is invoked (provided by the parent component)
     * and the seconds is reset to the startSeconds
     */
    const countDownOrReset = () => {
        if ((seconds - countDownIntervalInSeconds)<= 0) {
            setSeconds(startSeconds);
            timeExpired();
        } else {
            setSeconds(seconds - countDownIntervalInSeconds);
        }
    }; 

    return (
        <span className={countDownTimerStyles.wrapper} data-cy='timer-container'>
            <Timer  className={countDownTimerStyles.iconWrapper} data-cy='timer'/>
            <div className={countDownTimerStyles.timerMessageWrapper}>{countDownMessage} {seconds}s</div> 
        </span> 
    ); 
};

export default CountDownTimer;